// Même borne et même mention que les rendus Python, sans modifier la citation reçue.
import limites from './affichage_citations.json';

export function localisateurAffiche(valeur: string): string {
  // Les points de code Unicode sont comptés comme en Python (un emoji compte pour un).
  const caracteres = Array.from(valeur);
  return caracteres.length <= limites.max_localisateur
    ? valeur
    : caracteres.slice(0, limites.max_localisateur - Array.from(limites.mention).length).join('') + limites.mention;
}

/** JSON de présentation : les données originales restent disponibles pour les écritures et les exports. */
export function jsonAvecCitationsAffichees(valeur: unknown): string {
  return JSON.stringify(valeur, (cle, contenu: unknown) =>
    (cle === 'localisateur' || cle === 'locator') && typeof contenu === 'string'
      ? localisateurAffiche(contenu) : contenu);
}
